/** Ocean inner edge (WorldBuilder RingGeometry inner radius). */
export const WATER_RING_RADIUS = 94;
/** Matches PlayerController WATER_RING_INNER — player is in water when hypot > this. */
export const WATER_ZONE_INNER = 88;
export const WATER_EDGE_TOLERANCE = 2;
export const FISH_HOLD_S = 2.5;
export const FISH_MAX_CATCHES = 3;
export const FISH_HP_HEAL = 40;

/** True when the player is in/near the ocean ring (within 2m of radius ~94). */
export function isNearWaterEdge(x: number, z: number): boolean {
  const r = Math.hypot(x, z);
  if (Math.abs(r - WATER_RING_RADIUS) <= WATER_EDGE_TOLERANCE) return true;
  return r > WATER_ZONE_INNER && r <= WATER_RING_RADIUS + WATER_EDGE_TOLERANCE;
}

export class FpsFishing {
  private catches = 0;
  private progress = 0;

  reset(): void {
    this.catches = 0;
    this.progress = 0;
  }

  getCatches(): number {
    return this.catches;
  }

  getProgress(): number {
    return this.progress;
  }

  getProgressPct(): number {
    return Math.min(100, (this.progress / FISH_HOLD_S) * 100);
  }

  canFish(x: number, z: number): boolean {
    return this.catches < FISH_MAX_CATCHES && isNearWaterEdge(x, z);
  }

  /** Returns 'caught' when a flopper is reeled in this frame. */
  update(dt: number, x: number, z: number, holdingE: boolean): 'idle' | 'progress' | 'caught' {
    if (!this.canFish(x, z)) {
      this.progress = 0;
      return 'idle';
    }
    if (holdingE) {
      this.progress += dt;
      if (this.progress >= FISH_HOLD_S) {
        this.progress = 0;
        this.catches += 1;
        return 'caught';
      }
      return 'progress';
    }
    this.progress = 0;
    return 'idle';
  }
}
